import React from 'react'

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const GenericMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    return (
      <div ref={ref} style={style} className={className} aria-labelledby={labeledBy}>
        <span className="dropdown-menu-arrow"></span>
        <div>{React.Children.toArray(children)}</div>
      </div>
    )
  }
)
GenericMenu.displayName = 'GenericMenu'

export default GenericMenu
